import {
  IAnswerMap,
  ISelectDumbbellWeight,
  ISelectWeight,
  IStrengthAssessmentAnswer,
  IWizardStep,
  StrengthAssessmentStep,
  StrengthAssessmentSteps,
  StrengthAssessmentWizard,
} from 'fitbeat.gym-core';
import { Equipment, GymTypes, StrengthRatioForMuscleGroups } from 'fitbeat.models';
import produce from 'immer';
import {
  DUMBBELL_FLOW_SELECTED,
  MANUAL_FLOW_SELECTED,
  OPEN_SPECIFIC_QUESITONS,
  STRENGTH_ASSESSMENT_ANSWERED,
  STRENGTH_ASSESSMENT_COMPLETED_FAILURE,
  STRENGTH_ASSESSMENT_COMPLETED_LOADING,
  STRENGTH_ASSESSMENT_COMPLETED_SUCCESS,
  STRENGTH_ASSESSMENT_CONFIG_FAILURE,
  STRENGTH_ASSESSMENT_CONFIG_REQUEST,
  STRENGTH_ASSESSMENT_CONFIG_SUCCESS,
  StrengthAssessmentActionTypes,
  UNIBANDS_FLOW_SELECTED,
} from './actions';

export interface IStrengthAssessmentState {
  steps: StrengthAssessmentSteps;
  manualFlow: StrengthAssessmentSteps;
  dumbbellFlow: StrengthAssessmentSteps;
  uniBandsFlow: StrengthAssessmentSteps;
  currentStep: StrengthAssessmentStep | null;
  answers: IAnswerMap<IStrengthAssessmentAnswer>;
  strengthAssessmentResultsLoading: boolean;
  strengthAssessmentResultsError: string | null;
  userStrengthRatios: StrengthRatioForMuscleGroups | {};
  stepsAreLoading: boolean;
}

const initialState: IStrengthAssessmentState = {
  currentStep: null,
  steps: [],
  manualFlow: [],
  uniBandsFlow: [],
  dumbbellFlow: [],
  answers: {},
  strengthAssessmentResultsLoading: false,
  stepsAreLoading: false,
  strengthAssessmentResultsError: null,
  userStrengthRatios: {},
};

const strengthAssessmentWizard = new StrengthAssessmentWizard();

export const strengthAssessmentReducer = produce(
  (
    draft: IStrengthAssessmentState = initialState,
    action: StrengthAssessmentActionTypes,
  ): IStrengthAssessmentState => {
    switch (action.type) {
      case STRENGTH_ASSESSMENT_CONFIG_SUCCESS: {
        const { config } = action.payload;
        draft.steps = config.uniBandsFlow;
        draft.currentStep = config.uniBandsFlow[0];
        strengthAssessmentWizard.setResistanceStrategy(Equipment.UniversalBands, GymTypes.Home);
        draft.manualFlow = config.manualFlow;
        draft.uniBandsFlow = config.uniBandsFlow;
        draft.dumbbellFlow = config.dumbbellFlow;
        draft.userStrengthRatios = config.userStrengthRatios;
        draft.stepsAreLoading = false;
        break;
      }
      case STRENGTH_ASSESSMENT_CONFIG_REQUEST: {
        draft.stepsAreLoading = true;
        break;
      }
      case STRENGTH_ASSESSMENT_CONFIG_FAILURE: {
        draft.stepsAreLoading = false;
        break;
      }
      case STRENGTH_ASSESSMENT_ANSWERED: {
        const { answer, equipmentRequiringInstruction } = action.payload;
        const currentStep = action.payload.currentStep as IWizardStep<ISelectWeight | ISelectDumbbellWeight>;
        draft.answers = strengthAssessmentWizard.answer(
          {
            steps: draft.steps,
            currentStep,
            answers: draft.answers,
          },
          {
            userWeight: answer,
            primaryMuscleMover: currentStep.config.primaryMuscleMover,
            equipmentRequiringInstruction,
          },
        );
        break;
      }
      case STRENGTH_ASSESSMENT_COMPLETED_LOADING: {
        const shouldRefreshSteps = action.payload && action.payload.shouldRefreshSteps;
        draft.strengthAssessmentResultsLoading = true;
        draft.stepsAreLoading = !!shouldRefreshSteps;
        break;
      }
      case STRENGTH_ASSESSMENT_COMPLETED_SUCCESS: {
        const { userStrengthRatios } = action.payload;
        draft.strengthAssessmentResultsLoading = false;
        draft.userStrengthRatios = userStrengthRatios;
        break;
      }
      case STRENGTH_ASSESSMENT_COMPLETED_FAILURE: {
        draft.strengthAssessmentResultsLoading = false;
        draft.strengthAssessmentResultsError = action.payload.error;
        break;
      }
      case OPEN_SPECIFIC_QUESITONS: {
        const questionIds = action.payload.questionIds;
        draft.steps = draft.steps.filter((step, index)=> {
          if(questionIds.includes(step.questionId)) {
            return step;
          }
        });
        break;
      }
      case MANUAL_FLOW_SELECTED: {
        draft.steps = draft.manualFlow;
        break;
      }
      case UNIBANDS_FLOW_SELECTED: {
        draft.steps = draft.uniBandsFlow;
        strengthAssessmentWizard.setResistanceStrategy(Equipment.UniversalBands, GymTypes.Home);
        break;
      }
      case DUMBBELL_FLOW_SELECTED: {
        draft.steps = draft.dumbbellFlow;
        strengthAssessmentWizard.setResistanceStrategy(Equipment.Dumbbells, GymTypes.Indoor);
        break;
      }

    }
    return draft;
  },
);
